module.exports = __webpack_public_path__ + "img/tuhuang.35ff6a9d.png";